var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.html)?_c('div',{staticClass:"cms-plugins-liquid-renderer",class:{'highlighted': _vm.highlighted},domProps:{"innerHTML":_vm._s(_vm.html)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }